import React from "react";

export const Terms = () => (
  <div className="max-w-3xl mx-auto px-4 py-12 prose prose-slate">
    <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-navy">Terms & Conditions</h1>
    <p className="text-navy/70 mt-4">This is a demo build of Caleta Eats. Content below is placeholder and must be reviewed before going live.</p>
    <p className="text-navy/70 mt-3">By using this site you agree to the demo terms of use. All prices are indicative and all restaurants and menus are for demonstration purposes and can be edited from the admin dashboard.</p>
    <p className="text-navy/70 mt-3">Orders placed in demo mode are not real orders and no real payment is processed.</p>
  </div>
);

export const Privacy = () => (
  <div className="max-w-3xl mx-auto px-4 py-12">
    <h1 className="font-heading text-3xl sm:text-4xl font-extrabold text-navy">Privacy Policy</h1>
    <p className="text-navy/70 mt-4">This demo collects only the information required to process an order: first name, last name, email, phone and delivery address. Data is stored securely and is used solely to fulfil your order and provide customer support.</p>
    <p className="text-navy/70 mt-3">We do not sell your personal data to third parties. You can request deletion of your data at any time by contacting support.</p>
  </div>
);
